import { hasRequiredField } from '$core/helpers/has-required-field';
import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  Optional,
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[formControlName], input[required]',
})
export class RequiredMarkerDirective implements AfterViewInit, OnDestroy {
  @Input() public asterisk = true;
  public asteriskEl: HTMLElement;
  public labelEl: HTMLLabelElement;
  public oldLabel: string;

  public get controlEl(): HTMLElement {
    return this.elRef ? this.elRef.nativeElement : null;
  }

  public get controlID(): string {
    return this.controlEl ? this.controlEl.id : null;
  }

  constructor(
    private elRef: ElementRef,
    @Optional() private ngControl: NgControl,
    private ngZone: NgZone
  ) {}

  public ngAfterViewInit(): void {
    this.init();
  }

  private init() {
    if (
      !this.asterisk ||
      !this.controlID ||
      this.controlEl.closest('.toggles') ||
      !isNaN(+this.controlID)
    ) {
      return;
    }

    this.createAsteriskEl();
    this.labelEl = document.querySelector(`[for=${this.controlID}]`);

    this.checkRequired();
    this.ngControl.statusChanges.subscribe((e) => {
      this.checkRequired();
    });
  }

  private createAsteriskEl() {
    this.asteriskEl = document.createElement('span');
    this.asteriskEl.classList.add('text-danger');
    this.asteriskEl.innerText = ' *';
  }

  public checkRequired() {
    this.ngZone.runOutsideAngular((e) => {
      const isControlRequired = hasRequiredField(this.ngControl.control);

      if (this.controlEl.hasAttribute('required') || isControlRequired) {
        if (this.labelEl && this.asteriskEl) {
          this.labelEl.appendChild(this.asteriskEl);
        }
      } else {
        if (this.labelEl && this.asteriskEl) {
          if (this.labelEl.contains(this.asteriskEl)) {
            this.labelEl.removeChild(this.asteriskEl);
          }
        }
      }
    });
  }

  public cleanUp() {
    this.ngZone.runOutsideAngular((e) => {
      if (this.asteriskEl) {
        this.asteriskEl.remove();
        this.asteriskEl = null;
      }
    });
  }

  public ngOnDestroy(): void {
    this.cleanUp();
  }
}
